export class AudioContextProvider {
  private static audioContext?: AudioContext;

  static get context(): AudioContext {
    if (!AudioContextProvider.audioContext) {
      AudioContextProvider.audioContext = new AudioContext();
    }

    return AudioContextProvider.audioContext;
  }

  static get bufferSource(): AudioBufferSourceNode {
    const source = AudioContextProvider.context.createBufferSource();
    source.connect(AudioContextProvider.context.destination);
    source.addEventListener('ended', () => {
      source.disconnect();
    });

    return source;
  }
}
